
























































































import Vue from "vue";
import env from "@/utils/env";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import WatcherBadge from "@/components/WatcherBadge.vue";
import { WatcherBadgeModel } from "@/components/WatcherBadge.vue";
import { PatientDetailsViewModel, VentMode, PatientStatus, Watcher } from "@/models";
import WatcherModal from "../modals/WatcherModal.vue";

import VentAlarmSettings from "./vent/VentAlarmSettings.vue";
import VentMonitor from "./vent/VentMonitor.vue";
import VentSettings from "./vent/VentSettings.vue";
import VaeBadge from "./vae/VaeBadge.vue";

import _auth from "@/utils/auth";

@Component({
  components: {
    WatcherBadge,
    WatcherModal,
    VentAlarmSettings,
    VentMonitor,
    VentSettings,
    VaeBadge
  }
})
export default class PatientInfo extends Vue {
  @Prop() readonly patient!: PatientDetailsViewModel;

  // Set the VentMode enum as a property so that it is available to the template
  VentMode = VentMode;

  showModal = false;

  get watchers() {
    const watchers = this.patient?.watchers ?? [];
    // No need to show the current user that they are a watcher
    return watchers.filter((w: Watcher) => w.id !== _auth.user?.id);
  }

  get monitor() {
    return this.patient.ventMonitor;
  }

  get settings() {
    return this.patient.ventSetting;
  }

  get hasVentCode() {
    return !!this.settings?.ventTypeCode;
  }

  get ventTypeCode() {
    return this.settings?.ventTypeCode;
  }

  get hasSerialNumber() {
    return !!this.settings?.ventSerialNumber;
  }

  get hasVentName() {
    return !!this.settings?.ventName;
  }

  get ventSerialNumber() {
    return this.settings.ventSerialNumber;
  }

  get ventName() {
    return this.settings.ventName;
  }

  get mode() {
    return this.settings?.mode || VentMode.Unknown;
  }

  get hasWatchers() {
    return this.patient?.watchers?.length > 0;
  }

  get firstWatchersLimit() {
    const watchers = this.watchers;
    const results: WatcherBadgeModel[] = watchers.slice(0, env.watchersLimit);

    // If there are more watchers than the limit, remove the last watcher to show a badge
    // indicating the number of remaining watchers that couldn't be shown on the screen
    if (watchers.length > env.watchersLimit) {
      results.pop();
      const remaining = watchers.length - env.watchersLimit + 1;
      results.push({ label: `+${remaining}` });
    }

    return results;
  }

  get isStandby() {
    return this.mode === VentMode.Standby;
  }

  get showVentInfo() {
    return this.patient.ventStatus !== PatientStatus.Hidden;
  }

  get showVentFields() {
    return this.patient.ventStatus === PatientStatus.Active && !this.isStandby;
  }

  get isNonInvasive() {
    return this.settings.isNonInvasive;
  }
}
